"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedVaultUsersPaths = void 0;
exports.SharedVaultUsersPaths = {
    getSharedVaultUsers: (sharedVaultUuid) => `/v1/shared-vaults/${sharedVaultUuid}/users`,
    deleteSharedVaultUser: (sharedVaultUuid, userUuid) => `/v1/shared-vaults/${sharedVaultUuid}/users/${userUuid}`,
    designateSurvivor: (sharedVaultUuid, sharedVaultMemberUuid) => `/v1/shared-vaults/${sharedVaultUuid}/users/${sharedVaultMemberUuid}/designate-survivor`,
};
